import {RemoteGetRefundProtocolStatus} from 'data/usecases/private/refund/consult-refunds/remote-get-refund-protocol-status';
import {StubGetRefundProtocolStatus} from 'data/usecases/private/refund/consult-refunds/mocks/StubGetRefundProtocolStatus';
import {GetRefundProtocolStatus} from 'domain/usecases/private/refund/consult-refunds/get-refund-protocol-status';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetRefundProtocolStatus = (): GetRefundProtocolStatus =>
	new RemoteGetRefundProtocolStatus(
		makeBFFApiUrl(RefundFlowEndPoints.protocolStatus),
		makeAuthorizeHttpClientDecorator(),
	);

export const makeGetMockedRefundProtocolStatus = (): GetRefundProtocolStatus =>
	new StubGetRefundProtocolStatus();
